import Box from "@/common/components/Box";
import { cn } from "@/common/utils/cn";
import { MaintenanceForwardingDirectiveEntryStatus } from "@/features/privateCompanies/pages/Maintenance/Workflows/Show/features/forwardings/types/maintenanceForwarding.type";
import { MaintenanceForwardingsDirectiveEntryKlass } from "@/features/privateCompanies/pages/Maintenance/Workflows/Show/features/forwardings/types/maintenanceForwardingsDirectiveEntryKlasses.type";
import { useForwardingTabContext } from "@/features/privateCompanies/pages/Maintenance/Workflows/Show/hooks/forwardings/useForwardingTabContext";
import { useMemo } from "react";
import DirectiveEntryDiagnosticEntryCompleted from "../../Content/DiagnosticEntryCompleted";
import DirectiveEntryDiagnosticEntriesAdvance from "./Advance";
import DirectiveEntryDiagnosticEntriesDisapprove from "./Disapprove";
import DirectiveEntryDiagnosticEntriesRegress from "./Regress";

const MaintenanceWorkflowForwardingDirectiveEntrySectionDiagnosticEntry = () => {
  const { forwarding, forwardingUpdatedAt } = useForwardingTabContext<
    MaintenanceForwardingsDirectiveEntryKlass.DiagnosticEntry
  >();

  const isDiagnosticEntryPending = useMemo(() => {
    return forwarding?.directive_entry?.status && [
      MaintenanceForwardingDirectiveEntryStatus.AwaitingManualStart,
      MaintenanceForwardingDirectiveEntryStatus.InProgress,
      MaintenanceForwardingDirectiveEntryStatus.AwaitingClientReview,
    ].includes(forwarding?.directive_entry?.status);
  }, [forwardingUpdatedAt]);

  const isDiagnosticEntryCompleted = useMemo(() => {
    return forwarding?.directive_entry?.status && ![
      MaintenanceForwardingDirectiveEntryStatus.Pending,
      MaintenanceForwardingDirectiveEntryStatus.AwaitingManualStart,
      MaintenanceForwardingDirectiveEntryStatus.InProgress,
    ].includes(forwarding?.directive_entry?.status) || (
        forwarding?.directive_entry?.status === MaintenanceForwardingDirectiveEntryStatus.InProgress &&
        forwarding?.directive_entry?.last_review?.state === 'disapproved'
      );
  }, [forwardingUpdatedAt]);

  const isDiagnosticEntryAwaitingClientReview = useMemo(() => {
    return forwarding?.directive_entry?.status && [
      MaintenanceForwardingDirectiveEntryStatus.AwaitingClientReview
    ].includes(forwarding?.directive_entry?.status);
  }, [forwardingUpdatedAt]);

  const isDiagnosticEntryDisapproved = useMemo(() => {
    return forwarding?.directive_entry?.last_review?.state === 'disapproved';
  }, [forwardingUpdatedAt]);

  return (
    <Box className={cn(
      'p-4 flex flex-col gap-4',
      isDiagnosticEntryAwaitingClientReview && !isDiagnosticEntryDisapproved && 'bg-yellow-op-2',
    )}>
      <div className="flex items-center justify-between flex-wrap">
        <div className="flex flex-col">
          <p className="text-lg font-semibold">
            Diagnóstico e orçamento
          </p>

          {isDiagnosticEntryPending && (
            <p className="text-warning text-xs">
              Aguardando análise do diagnóstico e orçamento
            </p>
          )}
        </div>

        {isDiagnosticEntryAwaitingClientReview && (
          <div className="flex items-center gap-3">
            {isDiagnosticEntryDisapproved ? (
              <DirectiveEntryDiagnosticEntriesRegress />
            ) : (
              <DirectiveEntryDiagnosticEntriesDisapprove />
            )}

            <DirectiveEntryDiagnosticEntriesAdvance />
          </div>
        )}
      </div>

      {forwarding?.directive_entry && isDiagnosticEntryCompleted && (
        <DirectiveEntryDiagnosticEntryCompleted
          diagnosticId={forwarding.directive_entry.id}
          lastReview={forwarding.directive_entry.last_review}
          processStartedAt={forwarding.directive_entry.process_started_at}
          completedAt={forwarding.directive_entry.completed_at}
          technicalResponse={forwarding.directive_entry.technical_response}
          deadLineToCompleteInDays={forwarding.directive_entry.deadline_to_complete_in_days}
          totalValue={forwarding.directive_entry.total_value}
        />
      )}
    </Box>
  );
}

export default MaintenanceWorkflowForwardingDirectiveEntrySectionDiagnosticEntry;
